import { createContext, useContext, useState, useEffect } from "react";

const CartCtx = createContext(null);
const KEY = "localmakers_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
    });
    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const add = (product) => {
        setItems((prev) => {
            const existing = prev.find((p) => p.product_id === product.product_id);
            if (existing) {
                return prev.map((p) => p.product_id === product.product_id ? { ...p, quantity: p.quantity + 1 } : p);
            }
            // For "both"-fulfillment products, default the buyer's choice to delivery.
            const defaultChoice = product.fulfillment === "both" ? "delivery" : (product.fulfillment || null);
            return [...prev, { ...product, quantity: 1, fulfillment_choice: defaultChoice }];
        });
        // Remember which shop the buyer last added from so the Cart can offer a
        // one-tap "← Continue shopping at [Shop Name]" link back.
        try {
            if (product.listing_id) {
                localStorage.setItem("fromhere_last_shop_v1", JSON.stringify({
                    listing_id: product.listing_id,
                    name: product.listing_name || "the shop",
                }));
            }
        } catch {}
    };
    const remove = (id) => setItems((p) => p.filter((x) => x.product_id !== id));
    const setQty = (id, q) => setItems((p) => p.map((x) => x.product_id === id ? { ...x, quantity: Math.max(1, q) } : x));
    // Let the cart page flip a "both" product between delivery and collection.
    const setFulfillmentChoice = (id, choice) => setItems((p) =>
        p.map((x) => x.product_id === id ? { ...x, fulfillment_choice: choice } : x)
    );
    const clear = () => setItems([]);
    const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);

    return <CartCtx.Provider value={{ items, add, remove, setQty, setFulfillmentChoice, clear, total, count }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
